import { render, staticRenderFns } from "./c-content-chart-ci-bp.vue?vue&type=template&id=10b394a6&"
import script from "./c-content-chart-ci-bp.vue?vue&type=script&lang=js&"
export * from "./c-content-chart-ci-bp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports